import { Box } from '@chakra-ui/react';
import type { SanityImage } from '@time-line/components/types';
import { useImage } from 'lib/sanity';
import Img from 'next/image';

interface ThumbnailProps {
  beforeImage: SanityImage;
  afterImage: SanityImage;
  handleThumbnailClick: () => void;
  isActive?: boolean;
}

export function Thumbnail({
  beforeImage,
  afterImage,
  isActive,
  handleThumbnailClick,
}: ThumbnailProps) {
  const beforeImageProps = useImage(beforeImage, { ratio: 1 / 1 });
  const afterImageProps = useImage(afterImage, { ratio: 1 / 1 });

  return (
    <Box
      as="button"
      className="thumbnail"
      onClick={() => {
        handleThumbnailClick();
      }}
      w={{ base: '100%', lg: '80px' }}
      h={{ base: '100%', lg: '80px' }}
      overflow="hidden"
      borderRadius="base"
      position="relative"
      transition="opacity 0.2s ease-in-out"
      opacity={isActive ? 1 : 0.6}
      _hover={{ opacity: 1 }}
    >
      <Box
        position="absolute"
        top="0"
        left="0"
        right="0"
        bottom="0"
        borderWidth="1px"
        borderColor={isActive ? 'gray.600' : 'transparent'}
        borderRadius="base"
        zIndex={4}
      />
      {afterImageProps && (
        <Img
          {...afterImageProps}
          alt={`${afterImageProps.alt}-thumbnail`}
          sizes="(min-width: 960px) 60px, 20vw"
        />
      )}
      <Box
        position="absolute"
        top={0}
        left={0}
        bottom={0}
        borderRight="1px solid"
        borderColor="gray.50"
        w="50%"
        h="100%"
        zIndex={2}
      />
      {beforeImageProps && (
        <Box
          position="absolute"
          top={0}
          left={0}
          right={0}
          bottom={0}
          zIndex={1}
          clipPath="polygon(0 0, 50% 0, 50% 100%, 0 100%)"
        >
          <Img
            {...beforeImageProps}
            alt={`${beforeImageProps.alt}-thumbnail`}
            sizes="(min-width: 960px) 60px, 20vw"
          />
        </Box>
      )}
    </Box>
  );
}
